export const saveSubscriptionTerms = async (save: () => Promise<any>, errorMessage = 'Terms acceptance was not saved'): Promise<void> => {
  const result = await save()
  if (!result || result.error || !result.payload?.data?.termsLogId) {
    throw new Error(errorMessage)
  }
}
